{
  "id": "my_track_01",
  "name": "My Track",
  "theme": "sky_meadow",
  "targetSeconds": 30,
  "spawn": { "x": 64, "y": 640 },
  "finishX": 4224,
  "killY": 960,
  "segments": [
    { "type": "checkpoint", "x": 64, "y": 640 },
    { "type": "ground", "x": 0, "y": 640, "w": 4416, "h": 32, "style": "stone_slab" },
    { "type": "item_box", "x": 512, "y": 576 },
    { "type": "obstacle", "x": 768, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "ramp", "x": 1024, "y": 576, "w": 256, "h": 64, "dir": "up", "style": "stone_slab" },
    { "type": "ground", "x": 1280, "y": 576, "w": 512, "h": 64, "style": "stone_slab" },
    {
      "type": "ramp",
      "x": 1792,
      "y": 576,
      "w": 256,
      "h": 64,
      "dir": "down",
      "style": "stone_slab"
    },
    { "type": "checkpoint", "x": 2112, "y": 640 },
    { "type": "ramp", "x": 2304, "y": 512, "w": 256, "h": 128, "dir": "up", "style": "stone_slab" },
    { "type": "ground", "x": 2560, "y": 512, "w": 384, "h": 128, "style": "stone_slab" },
    {
      "type": "ramp",
      "x": 2944,
      "y": 512,
      "w": 256,
      "h": 128,
      "dir": "down",
      "style": "stone_slab"
    },
    { "type": "platform", "x": 3392, "y": 512, "w": 192, "h": 32, "style": "stone_slab" },
    { "type": "item_box", "x": 3456, "y": 448 },
    { "type": "spiked_stone", "x": 3840, "y": 640 },
    { "type": "decor", "id": "flower_giant", "x": 320, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "mushroom_tree", "x": 1536, "y": 576, "layer": "mid" },
    { "type": "decor", "id": "grass_tuft", "x": 192, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "rock_small", "x": 2752, "y": 512, "layer": "fg" },
    { "type": "decor", "id": "finish_island", "x": 4224, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flag_celebration", "x": 4352, "y": 640, "layer": "fg" }
  ]
}
